import { createAction } from 'redux-actions';
import { push } from 'react-router-redux';

import { unserialize, normalizeCatalog } from './serializer';

const types = {
  querySegmentsSuccess: 'querySegmentsSuccess',
  querySegmentsInProgress: 'querySegmentsInProgress',
  querySegmentsFailed: 'querySegmentsFailed',
  findSegmentByIdSuccess: 'findSegmentByIdSuccess',
  findSegmentByIdInProgress: 'findSegmentByIdInProgress',
  findSegmentByIdFailed: 'findSegmentByIdFailed',
  updateSegmentByIdSuccess: 'updateSegmentByIdSuccess',
  updateSegmentByIdInProgress: 'updateSegmentByIdInProgress',
  updateSegmentByIdFailed: 'updateSegmentByIdFailed',
  deleteSegmentByIdSuccess: 'deleteSegmentByIdSuccess',
  deleteSegmentByIdInProgress: 'deleteSegmentByIdInProgress',
  deleteSegmentByIdFailed: 'deleteSegmentByIdFailed',
  createSegmentInProgress: 'createSegmentInProgress',
  createSegmentFailed: 'createSegmentFailed',
  createSegmentSuccess: 'createSegmentSuccess',
  findAvailableFiltersInProgress: 'findAvailableFiltersInProgress',
  findAvailableFiltersSuccess: 'findAvailableFiltersSuccess',
  findAvailableFiltersFailed: 'findAvailableFiltersFailed'
};

const querySegmentsSuccess = createAction(types.querySegmentsSuccess);
const querySegmentsInProgress = createAction(types.querySegmentsInProgress);
const querySegmentsFailed = createAction(types.querySegmentsFailed);
const deleteSegmentByIdSuccess = createAction(types.deleteSegmentByIdSuccess);
const deleteSegmentByIdInProgress = createAction(
  types.deleteSegmentByIdInProgress
);
const deleteSegmentByIdFailed = createAction(types.deleteSegmentByIdFailed);

const findAvailableFiltersInProgress = createAction(
  types.findAvailableFiltersInProgress
);

const findAvailableFiltersSuccess = createAction(
  types.findAvailableFiltersSuccess
);

const findAvailableFiltersFailed = createAction(
  types.findAvailableFiltersFailed
);

/**
 * Segment's page size
 */
export const PAGE_SIZE = 100;

/**
 *
 * @param {Object} query query filter object.
 *                 Contains q, page, limit, and sort.
 *                 All optionals.
 */
const querySegments = query => {
  return (dispatch, getState, Api) => {
    dispatch(querySegmentsInProgress());

    const segmentModule = Api.getModule('segment');
    segmentModule.adapter.token = getState().session.user.token;
    segmentModule.adapter.communityId = getState().session.profile.community.id;

    return segmentModule
      .querySegments(query)
      .then(response => {
        const list = response.content;
        const segments = list.map(segment => unserialize(segment));
        dispatch(querySegmentsSuccess(segments));
      })
      .catch(error => {
        dispatch(
          querySegmentsFailed({
            apiError: error.apiErrors
          })
        );
      });
  };
};

const deleteSegment = id => {
  return (dispatch, getState, Api) => {
    dispatch(deleteSegmentByIdInProgress());

    const segmentModule = Api.getModule('segment');
    segmentModule.adapter.token = getState().session.user.token;
    segmentModule.adapter.communityId = getState().session.profile.community.id;

    return segmentModule
      .deleteSegmentById(id)
      .then(() => {
        dispatch(deleteSegmentByIdSuccess(id));
        Promise.resolve();
      })
      .catch(error => {
        dispatch(
          deleteSegmentByIdFailed({
            apiError: error.apiErrors
          })
        );
      });
  };
};

const findAvailableFilters = () => {
  return (dispatch, getState, Api) => {
    const segmentModule = Api.getModule('segment');
    segmentModule.adapter.token = getState().session.user.token;
    segmentModule.adapter.communityId = getState().session.profile.community.id;

    dispatch(findAvailableFiltersInProgress());

    const localFilters = getState().segments.filters;
    if (localFilters && localFilters.length > 0) {
      dispatch(
        findAvailableFiltersSuccess({
          filters: localFilters
        })
      );
      return Promise.resolve(localFilters);
    } else {
      return segmentModule
        .findCatalog()
        .then(response => {
          const filters = normalizeCatalog(response);
          dispatch(
            findAvailableFiltersSuccess({
              filters
            })
          );
          return Promise.resolve(filters);
        })
        .catch(error => {
          dispatch(
            findAvailableFiltersFailed({
              apiError: error.apiErrors
            })
          );
          return Promise.reject(error);
        });
    }
  };
};

// ------------------------------------------------------------ segmentos v2
// El editor nuevo trabaja con el segmento tal cual lo devuelve townhall (ver
// rules.js); estas acciones no tocan la lista guardada en el store.

/** "Ana Paz" con name como objeto ({ firstName, lastName }) o texto. */
export const personName = person => {
  const name = person && person.name;
  if (name && typeof name === 'object') {
    return [name.firstName, name.lastName].filter(Boolean).join(' ');
  }
  return (
    name ||
    [person && person.firstName, person && person.lastName]
      .filter(Boolean)
      .join(' ')
  );
};

const segmentModuleFor = (getState, Api) => {
  const segmentModule = Api.getModule('segment');
  segmentModule.adapter.token = getState().session.user.token;
  segmentModule.adapter.communityId = getState().session.profile.community.id;
  return segmentModule;
};

/** El segmento como lo guarda townhall (con inFilters, memberFilters, individualIds). */
const loadSegment = id => (dispatch, getState, Api) =>
  segmentModuleFor(getState, Api).findSegmentById(id);

/** Crea o actualiza (con id) y vuelve a Configuración → Segmentos. */
const saveSegment = (body, id) => (dispatch, getState, Api) => {
  const segmentModule = segmentModuleFor(getState, Api);
  const request = id
    ? segmentModule.updateSegmentById({ ...body, id })
    : segmentModule.createSegment(body);
  return request.then(response => {
    dispatch(push('/settings/SEGMENTS'));
    return response;
  });
};

const previewSegment = body => (dispatch, getState, Api) =>
  segmentModuleFor(getState, Api).previewSegment(body);

const findSegmentMembers = id => (dispatch, getState, Api) =>
  segmentModuleFor(getState, Api).findSegmentMembers(id);

/** Personas de la comunidad por nombre o documento (para el segmento manual). */
const searchPeople = q => (dispatch, getState, Api) => {
  const communityModule = Api.getModule('community');
  communityModule.adapter.token = getState().session.user.token;
  communityModule.adapter.communityId = getState().session.profile.community.id;
  return communityModule.queryUsers({ q, limit: 20 }).then(response =>
    (
      (response && response.individuals && response.individuals.content) ||
      []
    ).map(person => ({
      id: person.id,
      name: personName(person),
      document:
        person.personalId && person.personalId.number
          ? person.personalId.number
          : ''
    }))
  );
};

export { types };
export default {
  querySegments,
  deleteSegment,
  findAvailableFilters,
  loadSegment,
  saveSegment,
  previewSegment,
  findSegmentMembers,
  searchPeople
};
